import React, { Component } from 'react'
import callAPI from '../../../../../helpers/callAPI'

class ModelSelect extends Component {
    state = {
        dataLoaded: false,
        year: this.props.year,
        make: this.props.make,
        models: [],
    }

    componentDidMount() {
        // Fetch the years
        const fetchData = async () => {
            const result = callAPI(`vehicleInfo/getModels/${this.state.make}?year=${this.state.year}`, 'GET')

            if (result['success'] === true) {
                this.setState({
                    ...this.state,
                    dataLoaded: true,
                    models: result.models,
                })
            } else if (result['success'] === false) {
                console.log('Error fetching vehicle models.')
            } else {
                console.log('Error fetching vehicle models.')
            }
        }
        fetchData()
    }

    render() {
        return this.state.dataLoaded ? (
            <select className="form-control" onChange={(e) => this.props.handleChangeModel(e)}>
                <option></option>
                {this.state.models.map((model) => {
                    return <option value={model}>{model}</option>
                })}
            </select>
        ) : (
            <select className="form-control">
                <option> - </option>
            </select>
        )
    }
}

export default ModelSelect
